import {
  Solar,
  Lunar,
  Foto,
  Tao,
  NineStar,
  EightChar,
  SolarWeek,
  SolarMonth,
  SolarSeason,
  SolarHalfYear,
  SolarYear,
  LunarMonth,
  LunarYear,
  LunarTime,
  ShouXingUtil,
  SolarUtil,
  LunarUtil,
  FotoUtil,
  TaoUtil,
  HolidayUtil,
  NineStarUtil,
  I18n
} from '@/public/utils/lunar/lunar.js'

// 通过阳历日期获取对应的农历（优先节假日名称显示）
const getLunarText = date => {
  const lunarDate = Lunar.fromDate(date)
  const holidayDate = getLunarHoliday(date)

  // 判断是否是节假日，优先节假日名称显示
  if (holidayDate) {
    return holidayDate
  }

  // 判断是否为农历的一号，用月份来显示（1号则显示为X月）
  if (lunarDate.getDay() === 1) {
    return lunarDate.getMonthInChinese() + '月'
  }

  return lunarDate.getDayInChinese()
}

// 获取当前日期对应的节假日名称（'元旦节','春节','清明节','劳动节','端午节','中秋节','国庆节','国庆中秋'）
const getLunarHoliday = date => {
  const lunarDate = Lunar.fromDate(date)
  const lunarDateYear = lunarDate.getYear()
  const lunarDateMonth = lunarDate.getMonth() // 闰月为负数，需要取绝对值
  const lunarDateDay = lunarDate.getDay()
  const lunarDateDayInChinese = lunarDate.getMonth()
  // 获取阴历对应的节日名称
  const lunarHolidayDate = Lunar.fromYmd(lunarDateYear, lunarDateMonth, lunarDateDay)
  // 闰月-阴历对应的节日名称
  const lunarHolidayDateIn = Lunar.fromYmd(lunarDateYear, lunarDateDayInChinese, lunarDateDay)
  const lunarHoliday = lunarHolidayDate && lunarHolidayDate.getFestivals()
  if (lunarHoliday.length > 0) {
    return lunarHoliday[0]
  }
  // 获取阳历对应的节日名称
  const solarDate = Solar.fromDate(date)
  const solarDateYear = solarDate.getYear()
  const solarDateMonth = solarDate.getMonth() // 闰月为负数，需要取绝对值
  const solarDateDay = solarDate.getDay()
  const solarHolidayDate = Solar.fromYmd(solarDateYear, solarDateMonth, solarDateDay)
  const solarHoliday = solarHolidayDate && solarHolidayDate.getFestivals()
  if (solarHoliday && solarHoliday.length > 0) {
    return solarHoliday[0]
  }
  // 获取当前日期对应的节气名称
  const lunarDateJie = lunarHolidayDateIn.getJieQi()
  if (lunarDateJie) {
    return lunarDateJie
  }
  return false
}

export {
  Solar,
  Lunar,
  Foto,
  Tao,
  NineStar,
  EightChar,
  SolarWeek,
  SolarMonth,
  SolarSeason,
  SolarHalfYear,
  SolarYear,
  LunarMonth,
  LunarYear,
  LunarTime,
  ShouXingUtil,
  SolarUtil,
  LunarUtil,
  FotoUtil,
  TaoUtil,
  HolidayUtil,
  NineStarUtil,
  I18n,
  getLunarText,
  getLunarHoliday
}



// WEBPACK FOOTER //
// ./src/public/utils/lunar/index.js